import { z } from 'zod';
import { nonEmptyString } from './common.ts';

export const setting = z.object({
  key: nonEmptyString,
  value: z.string(),
});
export type Setting = z.infer<typeof setting>;

// POST /api/tz
export const setTzInput = z.object({
  tz: nonEmptyString,
});
export type SetTzInput = z.infer<typeof setTzInput>;
